export default "__VITE_ASSET__DCad8OF3__"